import { render, staticRenderFns } from "./meter-permission.vue?vue&type=template&id=07faa5a1&scoped=true&"
import script from "./meter-permission.vue?vue&type=script&lang=js&"
export * from "./meter-permission.vue?vue&type=script&lang=js&"
import style0 from "./meter-permission.vue?vue&type=style&index=0&id=07faa5a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07faa5a1",
  null
  
)

export default component.exports